/**
 * 값 객체 기본 클래스
 * DDD의 Value Object 개념 구현
 */
export abstract class ValueObject<T> {
  /**
   * 값 객체 동등성 비교
   * 모든 속성이 같으면 같은 값 객체로 간주
   */
  equals(vo?: ValueObject<T>): boolean {
    if (vo === null || vo === undefined) {
      return false;
    }
    
    if (vo.constructor !== this.constructor) {
      return false;
    }
    
    return this.equalsCore(vo);
  }

  /**
   * 실제 동등성 비교 로직
   * 하위 클래스에서 구현
   */
  protected abstract equalsCore(vo: ValueObject<T>): boolean;

  /**
   * 불변성을 위한 복사본 생성
   */
  protected abstract copy(): ValueObject<T>;
}